import React from 'react';
import { ArrowLeftIcon, PlusIcon } from 'lucide-react';
type LayoutProps = {
  children: ReactNode;
  title: string;
  onBack?: () => void;
  onAction?: {
    label: string;
    onClick: () => void;
  };
};
const Layout = ({
  children,
  title,
  onBack,
  onAction
}: LayoutProps) => {
  return <div className="flex flex-col w-full min-h-screen bg-gray-100" data-id="element-33">
      {/* Mobile header */}
      <header className="bg-blue-600 text-white p-4 flex items-center justify-between shadow-md" data-id="element-34">
        <div className="flex items-center" data-id="element-35">
          {onBack && <button onClick={onBack} className="mr-3 p-1" data-id="element-36">
              <ArrowLeftIcon size={20} data-id="element-37" />
            </button>}
          <h1 className="text-xl font-semibold" data-id="element-38">{title}</h1>
        </div>
        {onAction && <button onClick={onAction.onClick} className="flex items-center bg-white text-blue-600 px-3 py-1 rounded-md font-medium" data-id="element-39">
            <PlusIcon size={18} className="mr-1" data-id="element-40" />
            {onAction.label}
          </button>}
      </header>
      {/* Content area */}
      <main className="flex-1 p-4 overflow-auto" data-id="element-41">{children}</main>
      {/* Bottom navigation if needed */}
      <footer className="bg-white border-t border-gray-200 p-3 flex justify-around" data-id="element-42">
        <div className="text-blue-600 font-medium text-center text-xs" data-id="element-43">
          Keycard Reader Management
        </div>
      </footer>
    </div>;
};
export default Layout;